import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeleteEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeleteEventVO.validationSchema()
  );

  constructor(readonly value: RoomBrandBgDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandBgDeleteEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgDeleteEvent {
  roomId: RoomId;
}
